import {FormControl, ValidationErrors} from '@angular/forms';

export const whitespace  = (control: FormControl) => {
    const value = control.value ? String(control.value) : '';
    const isWhitespace = value.trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  };
  
// export function whitespaceValidator(form: FormControl): ValidationErrors {
//     return form.value.startsWith(" ") ? {whitespace: true} : null;
//   }
